import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IAuditoria,
  ICreateAuditoria,
  IListado,
  IQueryParam,
} from 'modelos/src';
import { HelperService } from '../../auxiliares/helper.service';
import { HttpService } from '../../auxiliares/http.service';

@Injectable({
  providedIn: 'root',
})
export class AuditoriasService {
  constructor(private http: HttpService) { }

  public listar(queryParams?: IQueryParam): Observable<IListado<IAuditoria>> {
    let params = HelperService.getQueryParams(queryParams);
    return this.http.get(`/auditorias`, { params });
  }

  public crear(
    dato: ICreateAuditoria,
  ): Observable<IAuditoria> {
    return this.http.post(`/auditorias`, dato);
  }

  public listarPorId(id: string): Observable<IAuditoria> {
    return this.http.get(`/auditorias/${id}`);
  }
}
